import { ProceedingInProgress as ProceedingInProgressResponse } from "../../api/HomePageResponseTypes";
import { Classifier } from "../../util/classifierManager";

export interface ProceedingInProgress extends Omit<ProceedingInProgressResponse, "liik" | "alamliik" | "seisund"> {
  liik: Classifier;
  alamliik: Classifier;
  seisund: Classifier;
}

export enum ColumnHeader {
  proceedingNr = "proceedingNr",
  proceedingType = "proceedingType",
  proceedingSubtype = "proceedingSubtype",
  state = "state",
  additionalData = "additionalData",
}
